import { ModsService, TModName } from '../mods';

export const getMod = <T extends TModName>(modName: T) =>
  ModsService.getOne(modName);
